import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {CareProgramModule} from "@shared/api/models/query/care-program.model";

@Injectable({
    providedIn: 'root'
})
export class CareProgramModulesService extends PaginatorService<CareProgramModule> {

    protected override get domainEntity() {
        return 'care-programs';
    };

    protected override get subdomainEntity() {
        return 'modules'
    }
}
